var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInspect = function SvgInspect(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62695 3.00879C1.62695 2.59458 1.96274 2.25879 2.37695 2.25879L13.6771 2.25879C14.0913 2.25879 14.4271 2.59458 14.4271 3.00879C14.4271 3.423 14.0913 3.75879 13.6771 3.75879L2.37695 3.75879C1.96274 3.75879 1.62695 3.423 1.62695 3.00879Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62695 7.52912C1.62695 7.11491 1.96274 6.77912 2.37695 6.77912L9.15703 6.77912C9.57124 6.77912 9.90703 7.11491 9.90703 7.52912C9.90703 7.94333 9.57124 8.27912 9.15703 8.27912L2.37695 8.27912C1.96274 8.27912 1.62695 7.94333 1.62695 7.52912Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62695 12.0481C1.62695 11.6338 1.96274 11.2981 2.37695 11.2981L5.76699 11.2981C6.1812 11.2981 6.51699 11.6339 6.51699 12.0481C6.51699 12.4623 6.1812 12.7981 5.76699 12.7981L2.37695 12.7981C1.96274 12.7981 1.62695 12.4623 1.62695 12.0481Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7592 16.9966C18.0568 16.7084 18.5316 16.716 18.8197 17.0136L22.166 20.4687C22.4541 20.7663 22.4465 21.2411 22.149 21.5293C21.8514 21.8174 21.3766 21.8098 21.0884 21.5123L17.7422 18.0571C17.4541 17.7596 17.4617 17.2848 17.7592 16.9966Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26467 13.6892C8.26467 10.3409 10.979 7.62663 14.3272 7.62663C17.6755 7.62663 20.3898 10.3409 20.3898 13.6892C20.3898 17.0374 17.6755 19.7517 14.3272 19.7517C10.979 19.7517 8.26467 17.0374 8.26467 13.6892ZM14.3272 9.12663C11.8074 9.12663 9.76467 11.1693 9.76467 13.6892C9.76467 16.209 11.8074 18.2517 14.3272 18.2517C16.847 18.2517 18.8898 16.209 18.8898 13.6892C18.8898 11.1693 16.847 9.12663 14.3272 9.12663Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInspect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "inspect.1719002e77dcc208016391875b60989f.svg";